import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../access/AuthLayout';

export function PrivacyPage(): JSX.Element {
  return (
    <AuthLayout>
      <article className="space-y-6 text-sm text-ccaanz-black">
        <header>
          <h1 className="text-2xl font-semibold">Privacy Notice</h1>
          <p className="mt-1 text-xs uppercase tracking-[0.08em] text-ccaanz-grey">
            CCAANZ Parish Administration Portal · last updated 15 May 2026
          </p>
        </header>

        <Section title="Who we are">
          The CCAANZ Parish Administration Portal is operated by the Confessing Anglicans Aotearoa
          New Zealand (CCAANZ) Registrar. We are the agency responsible for the personal information
          collected through this portal under the New Zealand Privacy Act 2020.
        </Section>

        <Section title="What we collect">
          <p>
            Your email address (for authentication), and parish personnel information (names, email
            addresses, phone numbers, and roles) that you or other parish administrators enter into
            the portal.
          </p>
        </Section>

        <Section title="Why we collect it">
          To authenticate you, maintain parish records, and send transactional communications
          related to those purposes.
        </Section>

        <Section title="Who can see it">
          Only authorised parish administrators and the CCAANZ Registrar, plus service providers who
          process it on our behalf. We do not sell or share your information.
        </Section>

        <Section title="How long we keep it">
          We retain your information while needed for the purposes stated above, then delete or
          archive it.
        </Section>

        <Section title="Your rights">
          You can ask to access, correct, or raise concerns about your information under the Privacy
          Act 2020.
        </Section>

        <Section title="Contact">
          <a className="underline" href="mailto:registrar@confessinganglicans.nz">
            registrar@confessinganglicans.nz
          </a>
        </Section>

        <div className="border-t border-edge pt-4 text-xs">
          <Link to="/" className="text-ccaanz-grey underline">
            Back to the portal
          </Link>
        </div>
      </article>
    </AuthLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="space-y-2">
      <h2 className="text-base font-semibold text-ccaanz-black">{title}</h2>
      <div className="space-y-2 leading-relaxed">{children}</div>
    </section>
  );
}
